/**
 * The price list on the public landing page, in USD.
 *
 * The payment provider's domain review wants pricing details on the domain
 * itself (task 28), so the landing page states them rather than only linking
 * to the marketing site. Read from the Live catalogue on 2026-10-04; the
 * labels match _PRICE_CATALOG in backend/shared/entitlements.py. The static
 * copy in public/index.html carries the same lines, and
 * src/publicIndexHtml.test.ts fails if the two drift. Change all three when
 * a price changes.
 */
export const PRICE_LINES: readonly string[] = [
  '1 Additional Run: $15',
  '5 Additional Runs: $60',
  'Core Starter: $25 per month, 2 runs a month',
  'Core Professional: $50 per month, 5 runs a month',
  'Core Plus: $75 per month, 10 runs a month',
] as const;
